  // 医生的职称
  const doctorProf = {
          1081: '住院医师',
          1082: '主治医师',
          1083: '副主任医师',
          1084: '主任医师',
          1085: '护士',
          1086: '护师',
          1088: '副主任护师',
          1089: '主任护师'
      }
      // 医生的开通的功能
  const doctorFn = [{
              color: 'https://image.oasisapp.cn/honghclient/crm/image/a6d56d86-8bb5-a660-3660-1d32139b1071.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/80ecabbf-b931-73bd-7abe-7f3bc0f426c4.png',
              name: '私人医生'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/ab5c43e6-0874-8cb9-ba32-2feea8921a7f.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/78f06aac-4dd4-e49a-5ddb-4643e3eb16e0.png',
              name: '护士上门'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/cf36e95e-ffeb-4824-c478-5ec18339fcd6.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/123cbfda-80c4-f9d1-6744-79b9379707ba.png',
              name: '门诊预约'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/a9c20ca9-dce5-9142-9192-005bb39c8f81.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/a3449f32-21d4-5431-3e48-4789c3637fe5.png',
              name: '电话咨询'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/3f61c165-225c-9e4d-31eb-a6c337a8ec28.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/e4adc8fe-8443-f471-2646-6583d6490327.png',
              name: '远程会诊'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/28ce2bec-16f4-b69a-f7c4-4937a83d7520.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/b87767b5-12ef-11ed-7077-83b6f9283934.png',
              name: '多学科团队'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/183cff9e-1b8b-7278-024d-49a6c4ea07f9.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/9c946d70-63b8-649b-0da7-66418bdbf757.png',
              name: '视频护理'
          },
          {
              color: 'https://image.oasisapp.cn/honghclient/crm/image/add316e4-f7f0-79ed-c7e8-da303917a119.png',
              grey: 'https://image.oasisapp.cn/honghclient/crm/image/70946da8-4d49-dc48-3d12-22edd2b75856.png',
              name: '医生上门'
          }
      ]
      // 医生的工作年限
  const workAgeCalc = function(num) {
      if (!num) {
          return '5年内'
      }
      let arr = ['5年内', '5年以上', '10年以上', '15年以上', '20年以上', '25年以上', '30年以上', '35年以上', '40年以上', '45年以上', '50年以上']
          // let index = 0
      let index = Math.floor(num / 5)
      if (index < 0) {
          index = 0
      }
      if (index > 10) {
          index = 9
      }
      return arr[index]
  }
  export { doctorProf, doctorFn, workAgeCalc }


// WEBPACK FOOTER //
// ./src/lib/correspondence.js